import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-propos-nous',
  templateUrl: './menu-propos-nous.component.html',
  styleUrls: ['./menu-propos-nous.component.scss']
})
export class MenuProposNousComponent {

}
